import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type FacebookProps = React.HTMLAttributes<HTMLDivElement> & {};

export const Facebook: React.FC<FacebookProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/facebook.svg"} alt="" />
    </div>
  );
};